/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./snack-bar.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../core/portal-directives";
import * as i3 from "./snack-bar.component";
var styles_UISnackBarComponent = [i0.styles];
var RenderType_UISnackBarComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UISnackBarComponent, data: {} });
export { RenderType_UISnackBarComponent as RenderType_UISnackBarComponent };
function View_UISnackBarComponent_1(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵand(0, null, null, 0))], null, null); }
export function View_UISnackBarComponent_0(_l) { return i1.ɵvid(0, [i1.ɵqud(402653184, 1, { portalHost: 0 }), (_l()(), i1.ɵand(16777216, null, null, 1, null, View_UISnackBarComponent_1)), i1.ɵdid(2, 147456, [[1, 4]], 0, i2.UIPortalHostDirective, [i1.ComponentFactoryResolver, i1.ViewContainerRef], null, null)], null, null); }
export function View_UISnackBarComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ui-snack-bar", [], null, null, null, View_UISnackBarComponent_0, RenderType_UISnackBarComponent)), i1.ɵdid(1, 49152, null, 0, i3.UISnackBarComponent, [], null, null)], null, null); }
var UISnackBarComponentNgFactory = i1.ɵccf("ui-snack-bar", i3.UISnackBarComponent, View_UISnackBarComponent_Host_0, {}, {}, []);
export { UISnackBarComponentNgFactory as UISnackBarComponentNgFactory };
